<mat-spinner [color]="'#1d2d9a'" [diameter]="spinnerSize"></mat-spinner>
